export const content = {
  ro: {
    nav: {
      home: "Acasă",
      library: "Library",
      journal: "Jurnal",
      portfolio: "Portofoliu",
      about: "Despre",
      services: "Servicii",
    },
    hero: {
      name: ["OANA", "MUDURA"],
      roles: ["Strategic Advisor", "Founder", "Writer", "Speaker"],
      intro:
        "De peste două decenii lucrez la intersecția dintre jurnalism, leadership, business și strategie de brand.",
      statement:
        "Brandurile nu se construiesc prin marketing. Se construiesc prin decizii.",
    },
    home_services: {
      label: "Servicii",
      title: "Cum lucrez",
      intro: "Trei arii de practică, o singură disciplină — claritatea înaintea execuției.",
    },
    home_works: {
      label: "Portofoliu",
      title: "Lucrări selectate",
      intro: "Companii pe care nu doar le-am consiliat, ci le-am imaginat, lansat și condus.",
    },
    home_courses: {
      label: "Library",
      title: "Cursuri",
      intro: "Serii video despre construcția brandurilor care merită să existe.",
    },
    home_journal: {
      label: "Jurnal",
      title: "Din jurnal",
      intro: "Idei, observații și lecții din strategie, business și procesul de a construi branduri.",
    },
    koolt: {
      label: "Brațul de execuție",
      lead: "Unde strategia devine execuție.",
      title: "Koolt Communications",
      body: "Gândirea, poziționarea și narativul sunt doar începutul. Pentru producție, campanii și activări la scară, colaborez cu Koolt Communications — agenția care transformă direcția strategică în lucru livrat.",
    },
    media: {
      label: "Perspective",
      title: "Perspective",
      intro:
        "Conferințe, apariții internaționale și conversații despre strategie, brand și încredere.",
      watch: "Vizionează",
      channelLabel: "Canalul meu YouTube",
      channelUrl: "https://www.youtube.com/@oanamudura",
    },
    principles: {
      label: "Principii",
      title: "Ce mă ghidează",
      items: [
        { t: "Strategia înaintea execuției", d: "Un marketing bun nu poate compensa decizii strategice slabe. Orice brand puternic începe cu claritate, nu cu campanii." },
        { t: "Identitatea creează valoare", d: "Organizațiile cresc atunci când știu cine sunt și de ce merită să existe. Poziționarea vine înaintea promovării." },
        { t: "Încrederea se compune", d: "Reputația se construiește prin decizii coerente, în timp. Vizibilitatea urmează încrederea — nu invers." },
        { t: "Excelența este strategia", d: "Calitatea, disciplina și coerența creează avantaj pe termen lung. Marketingul doar face excelența vizibilă." },
      ],
    },
    seo: {
      home: { title: "Oana Mudura — Strateg de brand, fondator și scriitor", description: "Platforma editorială a Oanei Mudura — consultant de strategie, fondator și scriitor. Douăzeci de ani la intersecția dintre jurnalism, leadership și strategie de brand." },
      about: { title: "Despre — Oana Mudura", description: "Douăzeci de ani de strategie trăită: jurnalism, leadership și construcția brandurilor care merită să existe." },
      services: { title: "Servicii — Oana Mudura", description: "Consultanță de strategie, brand și comunicare pentru lideri și companii care vor coerență, nu zgomot." },
      journal: { title: "Jurnal — Oana Mudura", description: "Eseuri și note despre strategie, brand, încredere și autoritate, dintr-o practică de două decenii." },
      portfolio: { title: "Portofoliu — Oana Mudura", description: "Proiecte selectate de brand și comunicare — de la concept la coerență." },
      library: { title: "Cursuri — Oana Mudura", description: "Serii video despre construcția brandurilor care merită să existe — de la concept la coerență." },
    },
    library: {
      label: "Knowledge Hub",
      title: "Library",
      intro:
        "Eseuri video, masterclass-uri de strategie și arhiva de podcast — un singur loc pentru gândirea aplicată despre brand.",
      watch: "Vezi introducerea",
      soon: "În curând",
      whatLabel: "Ce înveți",
      more: "Intră în curs",
      back: "Toate cursurile",
      perspectivesLabel: "The Perspectives",
      perspectivesIntro: "Eseuri video scurte — idei despre strategie, brand și încredere.",
      perspectivesBtn: "Vezi pe YouTube",
      perspectivesBtnUrl: "",
      masterclassesLabel: "The Masterclasses",
      masterclassesIntro: "Serii video complete despre construcția brandurilor care merită să existe.",
      masterclassesBtn: "Intră în curs",
      masterclassesBtnUrl: "",
      dialoguesLabel: "The Dialogues",
      dialoguesIntro: "Arhiva Koolt — conversații lungi despre business, leadership și cultură.",
      dialoguesBtn: "Vezi mai mult",
      dialoguesBtnUrl: "",
      lessonsLabel: "Lecții",
      aboutLabel: "Despre curs",
      manifestoLabel: "Manifestul cursului",
      curriculumLabel: "Programul",
      loadingCourse: "Se încarcă…",
    },
    portfolio: {
      label: "Portofoliu",
      title: "Lucrări",
      intro:
        "Companii pe care nu doar le-am consiliat, ci le-am imaginat, lansat și condus.",
      view: "Vezi proiectul",
      empty: "Curând, primele proiecte.",
      backCta: "Toate proiectele",
      achievementsLabel: "Realizări",
      overviewLabel: "Prezentare",
    },
    journal: {
      label: "Jurnal",
      title: "Eseuri",
      intro:
        "O colecție de idei, observații și lecții din strategie, business și procesul continuu de a construi branduri care merită să existe.",
      read: "Citește",
      readingLabel: "lectură",
      empty: "Curând, primele eseuri.",
      loading: "Se încarcă…",
      backCta: "Toate eseurile",
    },
    about: {
      label: "Despre",
      title: "Oana Mudura",
      lede: "Strateg de brand, fondator și autor. Douăzeci de ani la intersecția dintre jurnalism, leadership și strategie.",
      bio: [
        "Am condus redacții, am reconstruit branduri și am fondat companii. Fiecare recomandare pe care o ofer astăzi este trecută prin filtrul unei experiențe reale.",
        "Cred într-un singur fel de strategie: cea trăită. Claritatea aliniază leadershipul, ascute poziționarea, întărește comunicarea și construiește încredere. Orice organizație de succes crește de acolo.",
      ],
      practice: {
        label: "Arii de practică",
        groups: [
          { key: "Branduri", desc: "Identități coerente, de la poziționare la arhitectura sensului.", items: ["Strategie de Brand", "Poziționare", "Narațiune", "Identitate"] },
          { key: "Lideri", desc: "Voce, prezență media și autoritate construite cu discreție.", items: ["Executive Positioning", "Imagine Publică", "Thought Leadership"] },
          { key: "Instituții", desc: "Strategie integrată de comunicare pentru organizații.", items: ["Reputație", "Plan de Comunicare", "Afaceri Publice"] },
        ],
      },
      timeline: {
        label: "Parcurs",
        entries: [
          { years: "2014 — prezent", role: "Fondator & Strateg", org: "Koolt Communications", desc: "Consultanță de brand, executive positioning și strategie de comunicare." },
          { years: "2008 — 2014", role: "Manager · Știri Regionale", org: "Digi24 Oradea", desc: "Conducerea redacției și a echipei de știri regionale." },
          { years: "2004 — 2008", role: "News Anchor & Editor", org: "Transilvania TV & N24", desc: "Prezentare și coordonare editorială." },
          { years: "2001 — 2004", role: "Jurnalist", org: "Presă & Televiziune", desc: "Începuturile în jurnalism și comunicare." },
        ],
      },
      education: {
        label: "Educație",
        items: [
          { years: "", title: "Comunicare & Jurnalism", org: "Studii universitare" },
        ],
      },
      appearances: {
        label: "Apariții internaționale",
        items: [
          { name: "Fashion TV", place: "Dubai" },
          { name: "Beauty World", place: "Dubai" },
          { name: "Economia Încrederii", place: "Podcast · SUA" },
        ],
      },
    },
    services: {
      label: "Servicii",
      title: "SERVICII",
      intro:
        "Trei arii de practică, o singură disciplină: claritatea înaintea execuției. Nu ofer campanii — ofer decizii.",
      groups: [
        { key: "Branduri", desc: "Identități coerente, de la poziționare la arhitectura sensului. Construiesc branduri care știu cine sunt și de ce merită să existe.", items: ["Strategie de Brand", "Poziționare", "Narațiune", "Arhitectura sensului", "Identitate"] },
        { key: "Lideri", desc: "Voce, prezență media și autoritate construite cu discreție. Ajut liderii să comunice din poziția lor de forță.", items: ["Executive Positioning", "Imagine Publică", "Thought Leadership", "Media Training"] },
        { key: "Instituții", desc: "Strategie integrată de comunicare pentru organizații. Reputație construită prin decizii coerente, în timp.", items: ["Reputație", "Plan de Comunicare", "Afaceri Publice", "Strategie de Criză"] },
      ],
      outro: "Fiecare colaborare începe cu o conversație.",
    },
    contact: {
      label: "Contact",
      big: "SĂ VORBIM",
      dialogueLabel: "Pentru dialoguri strategice",
      intro: "Pentru colaborări, consiliere sau conferințe. Corespondența ajunge direct.",
      emailLabel: "Email",
      phoneLabel: "Telefon",
      linkedinLabel: "LinkedIn",
      email: "oana@oanamudura.com",
      phone: "+40 770 310 183",
      linkedin: "linkedin.com/in/oanamudura",
      linkedinUrl: "https://www.linkedin.com/",
      form: {
        title: "Corespondență",
        name: "Nume",
        email: "Email",
        message: "Mesaj",
        submit: "Trimite",
        sending: "Se trimite…",
        success: "Mulțumesc. Mesajul tău a fost primit.",
        error: "Mesajul nu a putut fi trimis.",
      },
    },
    footer: { city: "București · Oradea", rights: "Toate drepturile rezervate.", admin: "Redacție", tagline: "Strateg de brand · Founder · Writer" },
  },

  en: {
    nav: {
      home: "Home",
      library: "Library",
      journal: "Journal",
      portfolio: "Portfolio",
      about: "About",
      services: "Services",
    },
    hero: {
      name: ["OANA", "MUDURA"],
      roles: ["Strategic Advisor", "Founder", "Writer", "Speaker"],
      intro:
        "For more than two decades I've worked at the intersection of journalism, leadership, business and brand strategy.",
      statement:
        "Brands are not built through marketing. They are built through decisions.",
    },
    home_services: {
      label: "Services",
      title: "How I work",
      intro: "Three areas of practice, one discipline — clarity before execution.",
    },
    home_works: {
      label: "Portfolio",
      title: "Selected work",
      intro: "Companies I did not merely advise, but imagined, launched and led.",
    },
    home_courses: {
      label: "Library",
      title: "Courses",
      intro: "Video series on building brands that deserve to exist.",
    },
    home_journal: {
      label: "Journal",
      title: "From the journal",
      intro: "Ideas, observations and lessons from strategy, business and the craft of building brands.",
    },
    koolt: {
      label: "The Execution Arm",
      lead: "Where strategy becomes execution.",
      title: "Koolt Communications",
      body: "Thinking, positioning and narrative are only the beginning. For production, campaigns and activations at scale, I partner with Koolt Communications — the agency that turns strategic direction into delivered work.",
    },
    media: {
      label: "Perspectives",
      title: "Perspectives",
      intro:
        "Conferences, international appearances and conversations about strategy, brand and trust.",
      watch: "Watch",
      channelLabel: "My YouTube channel",
      channelUrl: "https://www.youtube.com/@oanamudura",
    },
    principles: {
      label: "Principles",
      title: "What guides me",
      items: [
        { t: "Strategy before execution", d: "Great marketing cannot compensate for poor strategic decisions. Every strong brand begins with clarity, not campaigns." },
        { t: "Identity creates value", d: "Organisations grow when they know who they are and why they deserve to exist. Positioning comes before promotion." },
        { t: "Trust compounds", d: "Reputation is built through consistent decisions over time. Visibility follows trust — not the other way around." },
        { t: "Excellence is the strategy", d: "Quality, discipline and coherence create long-term advantage. Marketing simply makes excellence visible." },
      ],
    },
    seo: {
      home: { title: "Oana Mudura — Brand Strategist, Founder & Writer", description: "The editorial platform of Oana Mudura — strategic advisor, founder and writer. Twenty years at the intersection of journalism, leadership and brand strategy." },
      about: { title: "About — Oana Mudura", description: "Twenty years of strategy that has been lived: journalism, leadership and building brands that deserve to exist." },
      services: { title: "Services — Oana Mudura", description: "Strategy, brand and communication advisory for leaders and companies that want coherence, not noise." },
      journal: { title: "Journal — Oana Mudura", description: "Essays and notes on strategy, brand, trust and authority, from two decades of practice." },
      portfolio: { title: "Portfolio — Oana Mudura", description: "Selected brand and communication projects — from concept to coherence." },
      library: { title: "Courses — Oana Mudura", description: "Video series on building brands that deserve to exist — from concept to coherence." },
    },
    library: {
      label: "Knowledge Hub",
      title: "Library",
      intro:
        "Video essays, strategy masterclasses and the podcast archive — one place for applied thinking on brand.",
      watch: "Watch intro",
      soon: "Coming soon",
      whatLabel: "What you learn",
      more: "Enter course",
      back: "All courses",
      perspectivesLabel: "The Perspectives",
      perspectivesIntro: "Short video essays — ideas on strategy, brand and trust.",
      perspectivesBtn: "Watch on YouTube",
      perspectivesBtnUrl: "",
      masterclassesLabel: "The Masterclasses",
      masterclassesIntro: "Complete video series on building brands that deserve to exist.",
      masterclassesBtn: "Enter course",
      masterclassesBtnUrl: "",
      dialoguesLabel: "The Dialogues",
      dialoguesIntro: "The Koolt archive — long-form conversations on business, leadership and culture.",
      dialoguesBtn: "View more",
      dialoguesBtnUrl: "",
      lessonsLabel: "Lessons",
      aboutLabel: "About the course",
      manifestoLabel: "The course manifesto",
      curriculumLabel: "The programme",
      loadingCourse: "Loading…",
    },
    portfolio: {
      label: "Portfolio",
      title: "Work",
      intro:
        "Companies I did not merely advise, but imagined, launched and led.",
      view: "View project",
      empty: "The first projects, soon.",
      backCta: "All projects",
      achievementsLabel: "Achievements",
      overviewLabel: "Overview",
    },
    journal: {
      label: "Journal",
      title: "Essays",
      intro:
        "A collection of ideas, observations and lessons from strategy, business and the ongoing process of building brands that deserve to exist.",
      read: "Read",
      readingLabel: "read",
      empty: "The first essays, soon.",
      loading: "Loading…",
      backCta: "All essays",
    },
    about: {
      label: "About",
      title: "Oana Mudura",
      lede: "Brand strategist, founder and writer. Twenty years at the intersection of journalism, leadership and strategy.",
      bio: [
        "I have led newsrooms, rebuilt brands and founded companies. Every recommendation I offer today has passed through the filter of real experience.",
        "I believe in only one kind of strategy: the kind that has been lived. Clarity aligns leadership, sharpens positioning, strengthens communication and builds trust. Every successful organisation grows from there.",
      ],
      practice: {
        label: "Areas of practice",
        groups: [
          { key: "Brands", desc: "Coherent identities, from positioning to the architecture of meaning.", items: ["Brand Strategy", "Positioning", "Narrative", "Identity"] },
          { key: "Leaders", desc: "Voice, media presence and authority built with discretion.", items: ["Executive Positioning", "Public Image", "Thought Leadership"] },
          { key: "Institutions", desc: "Integrated communication strategy for organisations.", items: ["Reputation", "Communication Plan", "Public Affairs"] },
        ],
      },
      timeline: {
        label: "Trajectory",
        entries: [
          { years: "2014 — present", role: "Founder & Strategist", org: "Koolt Communications", desc: "Brand consulting, executive positioning and communication strategy." },
          { years: "2008 — 2014", role: "Manager · Regional News", org: "Digi24 Oradea", desc: "Leading the newsroom and the regional news team." },
          { years: "2004 — 2008", role: "News Anchor & Editor", org: "Transilvania TV & N24", desc: "Anchoring and editorial coordination." },
          { years: "2001 — 2004", role: "Journalist", org: "Press & Television", desc: "Early years in journalism and communication." },
        ],
      },
      education: {
        label: "Education",
        items: [
          { years: "", title: "Communication & Journalism", org: "University studies" },
        ],
      },
      appearances: {
        label: "International appearances",
        items: [
          { name: "Fashion TV", place: "Dubai" },
          { name: "Beauty World", place: "Dubai" },
          { name: "The Economy of Trust", place: "Podcast · USA" },
        ],
      },
    },
    services: {
      label: "Services",
      title: "SERVICES",
      intro:
        "Three areas of practice, one discipline: clarity before execution. I don't offer campaigns — I offer decisions.",
      groups: [
        { key: "Brands", desc: "Coherent identities, from positioning to the architecture of meaning. I build brands that know who they are and why they deserve to exist.", items: ["Brand Strategy", "Positioning", "Narrative", "Architecture of meaning", "Identity"] },
        { key: "Leaders", desc: "Voice, media presence and authority built with discretion. I help leaders communicate from their position of strength.", items: ["Executive Positioning", "Public Image", "Thought Leadership", "Media Training"] },
        { key: "Institutions", desc: "Integrated communication strategy for organisations. Reputation built through consistent decisions over time.", items: ["Reputation", "Communication Plan", "Public Affairs", "Crisis Strategy"] },
      ],
      outro: "Every collaboration begins with a conversation.",
    },
    contact: {
      label: "Contact",
      big: "LET'S TALK",
      dialogueLabel: "For strategic conversations",
      intro: "For collaborations, advisory or speaking. Correspondence reaches me directly.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      linkedinLabel: "LinkedIn",
      email: "oana@oanamudura.com",
      phone: "+40 770 310 183",
      linkedin: "linkedin.com/in/oanamudura",
      linkedinUrl: "https://www.linkedin.com/",
      form: {
        title: "Correspondence",
        name: "Name",
        email: "Email",
        message: "Message",
        submit: "Send",
        sending: "Sending…",
        success: "Thank you. Your message has been received.",
        error: "The message could not be sent.",
      },
    },
    footer: { city: "Bucharest · Oradea", rights: "All rights reserved.", admin: "Editorial", tagline: "Brand strategist · Founder · Writer" },
  },
};

export const PORTRAIT =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_editorial-strategy-6/artifacts/tomg4gy4__89A7007-Edit.webp";
export const PORTRAIT_DARK =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_editorial-strategy-6/artifacts/rinq25a2__89A6712-Edit.webp";
export const PORTRAIT_STANDING =
  "https://customer-assets-lqy194kg.emergentagent.net/job_45463c51-fceb-46f3-92cc-32f9c1349ec9/artifacts/npk26jy8__89A6594-Edit%202.jpg";
